<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="80"
    >
      <FormItem label="公司" prop="name">
        <Input v-model="formValidate.name" placeholder="请输入公司名称"></Input>
      </FormItem>
      <FormItem label="地址">
        <Input v-model="formValidate.address" placeholder="请输入公司地址"></Input>
      </FormItem>
      <FormItem label="联系人">
        <Input v-model="formValidate.contacts" placeholder="请输入公司联系人"></Input>
      </FormItem>
      <FormItem label="电话">
        <Input v-model="formValidate.phone" placeholder="请输入联系电话"></Input>
      </FormItem>
      <FormItem label="邮箱">
        <Input v-model="formValidate.email" placeholder="请输入联系邮箱"></Input>
      </FormItem>
      <FormItem label="负责人" prop="user_id" :hidden="!isStoreManage">
        <Select v-model="formValidate.user_id" filterable>
          <Option
            v-for="item in userList"
            :value="item.id"
            :key="item.id"
            >{{ item.name }}</Option
          >
        </Select>
      </FormItem>
      <FormItem style="text-align: right">
        <Button @click="handleReset('formValidate')">重置</Button>
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          style="margin-left: 8px"
          >提交</Button
        >
      </FormItem>
    </Form>
  </div>
</template>

<script>
import params from '../argu-page/params.vue'
export default {
  components: { params },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      data: [],
      userList: [],
      isStoreManage: false,
      formValidate: {
        id: '',
        name: '',
        address: '',
        contacts: '',
        phone: '',
        email: '',
        user_id: '',
        userName: ''
      },
      ruleValidate: {
        name: [
          {
            required: true,
            message: '公司名称必须填写',
            trigger: 'blur'
          }
        ],
        address: [
          {
            required: true,
            message: '公司地址必须填写',
            trigger: 'blur'
          }
        ],
        contacts: [
          {
            required: true,
            message: '公司联系人必须填写',
            trigger: 'blur'
          }
        ],
        phone: [
          {
            required: true,
            message: '联系电话必须填写',
            trigger: 'blur'
          }
        ],
        user_id: [
          {
            required: true,
            message: '客户负责人必须选择',
            trigger: 'change'
          }
        ],
      }
    }
  },
  watch: {
    resetFlag (resetFlag) {
      this.handleReset('formValidate')
    }
  },
  methods: {
    setUserData (userList) {
      var data = new Array()
      for (var i = 0; i < userList.length; i++) {
        data[i] = { id: userList[i].id.toString(), name: userList[i].real_name }
      }
      this.userList = data
    },
    setIsStoreManage (flag) {
      this.isStoreManage = flag
    },
    setData (user) {
      this.formValidate.user_id = user.userId.toString()
      this.formValidate.userName = user.userName
    },
    setEditData (data) {
      this.formValidate.id = data.id
      this.formValidate.name = data.name
      this.formValidate.address = data.address
      this.formValidate.contacts = data.contacts
      this.formValidate.phone = data.phone
      this.formValidate.email = data.email
      this.formValidate.user_id = data.user_id.toString()
      this.formValidate.userName = data.sales_name
    },

    handleChange (newTargetKeys) {
      this.formValidate.permissions = newTargetKeys
    },
    filterMethod (data, query) {
      return data.label.indexOf(query) > -1
    },

    handleSubmit (name) {
      console.log(this.formValidate)
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('on-ok', this.formValidate)
        } else {
          this.$Message.error('失败!')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    }
  }
}
</script>
